import type { THIRD_PARTY_SENSOR_LINKED_APPLIANCES_TABLE_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/third-party-sensor-linked-appliances-table/third-party-sensor-linked-appliances-table.fr.ts";

export const THIRD_PARTY_SENSOR_LINKED_APPLIANCES_TABLE_ENGLISH_LOCALE = {
  globalSearchPlaceholder: "Search a value...",
  empty: "No linked appliance found...",
  headers: {
    name: "Name",
    modulatorCsId: "Modulator Cs Id",
    modulatorHwId: "Modulator Hw Id",
  },
  actions: {
    deleteLinkedAppliances: "Delete selected links",
  },
} satisfies typeof THIRD_PARTY_SENSOR_LINKED_APPLIANCES_TABLE_FRENCH_LOCALE;
